package api

import kotlinx.datetime.LocalDate

fun LocalDate.toApiDayOfWeek(): DayOfWeek {
    return when (this.dayOfWeek) {
        kotlinx.datetime.DayOfWeek.MONDAY -> DayOfWeek.MONDAY
        kotlinx.datetime.DayOfWeek.TUESDAY -> DayOfWeek.TUESDAY
        kotlinx.datetime.DayOfWeek.WEDNESDAY -> DayOfWeek.WEDNESDAY
        kotlinx.datetime.DayOfWeek.THURSDAY -> DayOfWeek.THURSDAY
        kotlinx.datetime.DayOfWeek.FRIDAY -> DayOfWeek.FRIDAY
        kotlinx.datetime.DayOfWeek.SATURDAY -> DayOfWeek.SATURDAY
        kotlinx.datetime.DayOfWeek.SUNDAY -> DayOfWeek.SUNDAY
    }
}


val ResourceType.Companion.DefaultWebAppThumbIcon get() = -5L
